"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTheme = void 0;
var styles_1 = require("@material-ui/core/styles");
var createBreakpoints_1 = __importDefault(require("@material-ui/core/styles/createBreakpoints"));
var palette_1 = require("./palette");
var typography_1 = require("./typography");
var components_1 = require("./components");
exports.createTheme = function (themeProps) {
    if (themeProps === void 0) { themeProps = {
        style: "light",
        platform: "generic",
    }; }
    var breakpoints = createBreakpoints_1.default({});
    var palette = palette_1.createPalette(themeProps);
    var typography = typography_1.createTypography(themeProps, palette, breakpoints);
    var spacing = 4;
    var internalProps = {
        palette: palette,
        typography: typography,
        spacing: spacing,
        breakpoints: breakpoints,
    };
    var overrides = components_1.createOverrides(internalProps);
    var props = components_1.createDefaultProps(internalProps);
    return styles_1.createTheme({
        palette: palette,
        typography: typography,
        spacing: spacing,
        overrides: overrides,
        props: props,
        shape: {
            borderRadius: 20,
        },
    });
};
